import { Autocomplete, Grid, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { getBusinessRelationsForUser } from '../../api';
import CustomButton from '../../designSystem/Button';
import CenteredCircularProgress from '../../designSystem/CircularProgress';

interface Business {
  id: number;
  businessName: string;
  identifier: string;
}

interface CompanyBusinessSearcherProps {
  setBusiness: (business: Business | null) => void;
  setSearched: (searched: boolean) => void;
  onSimulationSelect?: () => void;
}

const CompanyBusinessSearcher = (props: CompanyBusinessSearcherProps) => {
  const { setBusiness, setSearched, onSimulationSelect } = props;
  const [loading, setLoading] = useState(false);
  const [businesses, setBusinesses] = useState<Business[]>([]);
  const [businessSelected, setBusinessSelected] = useState<Business | null>(
    null,
  );

  const dispatch = useDispatch();

  const setUpBusinesses = async () => {
    setLoading(true);
    try {
      const results = await getBusinessRelationsForUser(dispatch);
      if (results) {
        const uniqueBusinesses = results.relations.filter(
          (business: Business, index: number, self: Business[]) =>
            index === self.findIndex((b: Business) => b.id === business.id),
        );
        setBusinesses(uniqueBusinesses);
      }
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  const handleChange = (
    _event: React.SyntheticEvent,
    newValue: Business | null,
  ) => {
    setSearched(false);
    setBusiness(newValue);
    setBusinessSelected(newValue);
  };

  useEffect(() => {
    void setUpBusinesses();
  }, []);

  if (loading) return <CenteredCircularProgress relative />;

  return (
    <div>
      <div style={{ padding: '10px 0px' }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={8}>
            <Autocomplete
              value={businessSelected}
              options={businesses}
              getOptionLabel={(option) =>
                `${option.businessName} - ${option.identifier}`
              }
              isOptionEqualToValue={(option, value) => option?.id === value?.id}
              renderInput={(params) => (
                <TextField {...params} label="Seleccionar una empresa" />
              )}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={4} textAlign="center">
            <CustomButton
              color="primary"
              onClick={() => {
                if (onSimulationSelect) {
                  onSimulationSelect();
                } else {
                  setSearched(true);
                }
              }}
              disabled={!businessSelected}
            >
              Seleccionar
            </CustomButton>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default CompanyBusinessSearcher;
